( function ($){

    console.log('slider');

    $ (document).ready (function ($){
        var swiper = new Swiper ('.widget_tf-text_with_image_slider .swiper-container', {
            // Optional parameters
            loop: true,
            slidesPerView: 1,
            slidesPerGroup: 1,
            // spaceBetween: -1,
            speed: 600,
            autoplay: {
                delay: 3000,
            },
            pagination: {
                el: '.widget_tf-text_with_image_slider .swiper-pagination',
                type: 'bullets',
                clickable: true,
            },


        });

        $ ('.widget_tf-text_with_image_slider .swiper-container').on ('mouseenter', function (e){
            swiper.autoplay.stop ()
        })
        $ ('.widget_tf-text_with_image_slider .swiper-container').on ('mouseleave', function (e){
            swiper.autoplay.start ()
        })

    });

} ) (jQuery);
